<template>
  <div class="assessment">
    <loading :active="isLoading" :is-full-page="true"></loading>
    <md-dialog class="confirm" :md-active.sync="submitSelfAssessment" :md-close-on-esc="false"
      :md-click-outside-to-close="false">
      <md-dialog-content>
        Please self evaluate to view your grades for this assessment
        <div class="assessment md-layout table-label-wrapper comment">
          <div class="md-layout-item table-label p10">
            <md-field>
              <label>Write a self assessment</label>
              <md-textarea v-model="submission.student_self_assessment"></md-textarea>
            </md-field>
          </div>
        </div>

        <div
          v-if="template && template.student_self_assessment && current_student && current_student.id && competencies_by_user[current_student.id]">
          <div class="text-align-left">
            <div :key="domain.id" v-for="domain in template.childrens">
              <div v-if="submissions_by_attempt[domain.id] && submissions_by_attempt[domain.id].status == 'attempt_submitted'">
                <div class="md-layout md-alignment-center-center grade-row">
                  <div class="md-layout-item show-competency">
                    <md-button v-if="domain.childrens.length" @click="
                      show_competency[domain.id] = !show_competency[domain.id]
                      " class="md-icon-button md-raised md-accent">
                      <md-icon>{{
                        show_competency[domain.id]
                        ? "arrow_drop_up"
                        : "arrow_drop_down"
                      }}</md-icon>
                    </md-button>
                  </div>
                  <div class="md-layout-item competency-title" @click="
                  show_competency[domain.id] = !show_competency[domain.id]
                    ">
                    <md-checkbox v-show="!domain.req_grading && domain.childrens.length == 0"
                      :disabled="true"
                      v-model="competencies_by_user[assessment.creator.id][domain.id].status">
                      {{ domain.weight }}. {{ domain.label }}</md-checkbox>
                    <label v-show="!domain.req_grading && domain.childrens.length != 0 || domain.req_grading">{{ domain.weight }}. {{ domain.label }}</label> <span
                      class="required" v-if="domain.req_grading">*</span>
                  </div>
                  <div class="md-layout-item md-xsmall-size-100 competency-grade">
                    <div v-if="domain.childrens.length == 0">
                      <grade-control :template="domain" :readonly="current_student.id != user.id"
                        :grading="template.grading"
                        @change="onChangeGrade(domain.id, $event, true, domain.req_grading, current_student.id)"
                        :value="competencies_by_user[current_student.id][domain.id].grade" />
                    </div>
                  </div>
                </div>
                <div v-if="domain.childrens.length && show_competency[domain.id]">
                  <div :key="competency.id" v-for="(competency, index) in domain.childrens" class="md-layout competency">
                    <div class="md-layout-item show-competency"></div>
                    <div class="md-layout-item sub-category">
                      <label class="md-checkbox" v-if="competency.parent.req_grading">{{ charFromCode(index) }}.
                        {{ competency.label }}</label>
                      <md-checkbox v-show="!competency.parent.req_grading
                        " :disabled="true
      "
      v-model="competencies_by_user[assessment.creator.id][competency.id].status">{{ charFromCode(index) }}.
                        {{ competency.label }}</md-checkbox>
                    </div>
                    <div class="md-layout-item md-xsmall-size-100 competency-grade">
                      <grade-control :template="domain.childrens[index]" :grading="template.grading"
                        @change="onChangeGrade(competency.id, $event, false, false, current_student.id)"
                        :value="competencies_by_user[current_student.id][competency.id].grade" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class @click="onDashboard">Go back to my dashboard</md-button>
        <md-button class="md-primary" @click="onComment">Comment</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog class="error" :md-active.sync="submitError" :md-close-on-esc="false" :md-click-outside-to-close="true">
      <md-dialog-content>
        <div>
          Field{{ errors.length > 1 ? "s" : "" }}
          <span :key="index" v-for="(error, index) in errors" class="">{{ index == 0 ? "" : ", " }}
            <span class="required">{{
              error.template.parent && error.template.parent.id && error.template.parent.parent
              ? error.template.parent.label + ": "
              : ""
            }}{{ error.template.label }}</span>
          </span> {{ errors.length > 1 ? "are" : "is" }} required.
        </div>
        <div>
          You have left {{ errors.length > 1 ? "them" : "it" }} empty and a value must be entered.
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised md-accent" @click="submitError = false">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-alert _md-active.sync="saved" md-title="Saved!" md-content="Your changes has been saved." />
    <md-dialog-confirm class="confirm" :md-active.sync="confirmAttemptSave" md-title
      md-content="Do you want to save the changes you have made to this section?" md-confirm-text="Yes, Save!" md-cancel-text="No"
      @md-cancel="onSaveCancel" @md-confirm="onSaveAttemptConfirm" />
    <md-dialog-confirm class="confirm" :md-active.sync="confirmAttemptSubmit" md-title
      md-content="Are you ready to submit this section?" md-confirm-text="Yes, Submit!" md-cancel-text="No"
      @md-cancel="onSaveCancel" @md-confirm="onSubmitAttemptConfirm" />
    <md-dialog-confirm class="confirm" :md-active.sync="confirmSave" md-title
      md-content="Do you want to save the changes you have made?" md-confirm-text="Yes, Save!" md-cancel-text="No"
      @md-cancel="onSaveCancel" @md-confirm="onSaveConfirm" />
    <md-dialog-confirm class="confirm" :md-active.sync="confirmLeave" md-title
      md-content="You are about leave this assessment. Do you want to save the changes you have made?"
      md-confirm-text="Yes, Save!" md-cancel-text="No" @md-cancel="onLeaveCancel" @md-confirm="onLeaveSave" />
    <md-dialog-confirm class="confirm" :md-active.sync="confirmSubmit" md-title
      md-content="Are you ready to submit this assessment?" md-confirm-text="Yes, Submit!" md-cancel-text="No"
      @md-cancel="onSaveCancel" @md-confirm="onSubmitConfirm" />
    <md-dialog-confirm class="confirm" :md-active.sync="confirmDelete" md-title
      md-content="Are you sure to delete this assessment?" md-confirm-text="Yes, Delete!" md-cancel-text="No"
      @md-cancel="onSaveCancel" @md-confirm="onDeleteConfirm" />
    <md-dialog :md-active.sync="confirmNewAssessment">
      <md-dialog-content>
        <h3 class="who-are-you-assessin">The assessment for the same start date exists in the system. Please select an assessment.</h3>
        <table class="assessment-table">
          <tr>
            <td></td>
            <th>Start Date</th>
            <th>Faculty</th>
            <th>Student</th>
            <th></th>
          </tr>
          <tr :key="assessmentItem.id" v-for="assessmentItem in confirmAssessmentList">
            <td><b>{{ assessmentItem.id == assessment.id ? 'Current' : '' }}</b></td>
            <td>{{ $moment.utc(+assessmentItem.startDate).format('MM/DD/YYYY') }}</td>
            <td>{{ assessmentItem.creator.firstName }} {{ assessmentItem.creator.lastName }}</td>
            <td>{{ assessmentItem.submissionsAll.edges[0].user.firstName }} {{ assessmentItem.submissionsAll.edges[0].user.lastName }}</td>
            <td>
              <a href="javascript:void(0)" @click="goToAssessment(assessmentItem.id, assessmentItem.submissionsAll.edges[0].user.id)">Edit</a>
            </td>
          </tr>
        </table>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="onConfirmNewAssessmentCancel">Cancel</md-button>
      </md-dialog-actions>
    </md-dialog>
    <ApolloQuery v-if="$route.params.id" ref="assessment" :query="require('../graphql/Assessment.gql')" :variables="{
      id: $route.params.id,
    }" @result="onAssessmentLoad">
      <template slot-scope="{ result: { loading, error, data } }">
        <div v-if="loading" class="loading apollo">Loading...</div>
        <div v-else-if="error" class="error apollo">An error occured</div>
        <div v-else-if="data">
          <div class="assessment md-elevation-4">
            <div v-show="isFaculty() || isAdmin" class="md-layout">
              <div class="md-layout-item p10">
                <div class="md-layout md-alignment-center-center">
                  <div class="md-layout-item p10 student-control-logo">
                    <ApolloQuery ref="users" :query="require('../graphql/Users.gql')" :variables="{
                      offset: 0,
                      limit: 0,
                      filter: {
                        id: student,
                      },
                      resident: resident,
                      role: 'student',
                    }">
                      <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading" class="loading apollo">
                          Loading...
                        </div>
                        <div v-else-if="error" class="error apollo">
                          An error occured
                        </div>
                        <div v-else-if="data" class>
                          <div v-if="data.users.edges && data.users.edges[0]" class="user-img extra big"
                            :style="{ 'background-image': 'url(\'' + httpEndpoint + data.users.edges[0].image + '\')' }">
                            <span v-if="!data.users.edges[0].image">{{ data.users.edges[0].firstName && data.users.edges[0].firstName[0]
                            }}{{ data.users.edges[0].lastName && data.users.edges[0].lastName[0] }}</span>
                          </div>
                        </div>
                        <div v-else class="no-result apollo"></div>
                      </template>
                    </ApolloQuery>
                  </div>
                  <div class="md-layout-item p10 student-control-col">
                    <div class="md-layout student-control">
                      <div class="md-layout-item prev">
                        <md-button @click="onPrevStudent" :disabled="currentStudentIndex <= 0"
                          class="md-icon-button md-elevation-4">
                          <md-icon>arrow_back</md-icon>
                        </md-button>
                      </div>
                      <div class="md-layout-item student">
                        <ApolloQuery ref="users" :query="require('../graphql/Users.gql')" :variables="{
                          offset: 0,
                          limit: 0,
                          filter: {
                            group: group,
                            status: 1,
                            group_status: 1,
                          },
                          resident: resident,
                          role: 'student',
                        }" @result="onStudentLoad">
                          <template slot-scope="{ result: { loading, error, data } }">
                            <div v-if="loading" class="loading apollo">
                              Loading...
                            </div>
                            <div v-else-if="error" class="error apollo">
                              An error occured
                            </div>
                            <div v-else-if="data" class>
                              <md-field class="md-field-select">
                                <label>Student</label>
                                <md-select @md-selected="onStudentChange" class="students" v-model="student">
                                  <md-option :key="user.id" :value="user.id" v-for="user in data.users.edges">{{
                                    user.firstName }} {{ user.lastName }}</md-option>
                                </md-select>
                              </md-field>
                            </div>
                            <div v-else class="no-result apollo">No result</div>
                          </template>
                        </ApolloQuery>
                      </div>
                      <div class="md-layout-item next">
                        <md-button @click="onNextStudent" :disabled="currentStudentIndex >= students.length - 1"
                          class="md-icon-button md-elevation-4">
                          <md-icon>arrow_forward</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </div>
                  <div class="md-layout-item p10 student-flags-col">
                    <md-checkbox v-model="submission.rotation">Rotation</md-checkbox>
                    <md-checkbox v-model="submission.absent">Absent</md-checkbox>
                    <md-checkbox v-model="submission.void_value">Cancelled</md-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <md-divider v-if="isFaculty() || isAdmin"></md-divider>
            <div class="md-layout">
              <div class="md-layout-item p10 assessment-type-section">
                <md-button v-if="assessment.type == 'daily'" class="assessment-type md-primary md-raised">
                  <md-icon>event</md-icon>
                  <div>Daily</div>
                </md-button>
                <md-button v-if="assessment.type == 'monthly'" class="assessment-type md-primary md-raised">
                  <md-icon>date_range</md-icon>
                  <div>Monthly</div>
                </md-button>
                <md-button v-if="assessment.type == 'progress'" class="assessment-type md-primary md-raised">
                  <md-icon>trending_up</md-icon>
                  <div>Progress</div>
                </md-button>
                <md-button v-if="assessment.type == 'competency'" class="assessment-type md-primary md-raised">
                  <md-icon>verified_user</md-icon>
                  <div>Competency</div>
                </md-button>
              </div>
              <div class="md-layout-item p10">
                <div class="md-layout">
                  <div v-if="assessment.type == 'daily'" class="md-layout-item p10">
                    Date: {{ startDate }}
                  </div>
                  <div v-if="assessment.type == 'monthly'" class="md-layout-item p10">
                    Month:
                    {{
                      $moment(parseInt(assessment.startDate))
                        .utc()
                        .format("MMMM")
                    }}
                  </div>
                  <div v-if="assessment.type == 'daily'" class="md-layout-item p10">
                    Time of the day: {{ assessment.startTime.toUpperCase() }}
                  </div>
                  <div v-if="assessment.type == 'competency' || assessment.type == 'progress'" class="md-layout-item p10">
                    Start Date: {{ startDate }}
                  </div>
                  <div v-if="assessment.type == 'competency' || assessment.type == 'progress'" class="md-layout-item p10">
                    Completion Date: {{ endDate }}
                  </div>
                </div>
                <div class="md-layout" v-if="assessment.type == 'daily'">
                  <div class="md-layout-item p10">
                    <div>Procedure note</div>
                    <md-field v-if="isFaculty() || isAdmin">
                      <label>Write a note or a comment about this procedure
                        here</label>
                      <md-textarea v-model="submission.procedure_note"></md-textarea>
                    </md-field>
                    <div v-if="isStudent()">
                      <div class="procedure-note">
                        {{ submission.procedure_note }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="md-layout table-label-wrapper">
            <div class="md-layout-item table-label p10">
              <h1>{{ assessment.type | capitalize }} Assessment</h1>
            </div>
            <div v-if="isFaculty() || isAdmin" class="md-layout-item text-right p10 table-status">
              <md-field class="md-field-select no-top-label">
                <label for="base-grade">Base Grade</label>
                <md-select @md-selected="onBaseGradeSelect" v-model="base_grade" name="base-grade" id="base-grade"
                  :disabled="submission.status == 'submitted'">
                  <md-option :key="grade.key" v-for="grade in grades" :value="grade.key">{{ grade.label }}</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="history-section md-layout-item md-elevation-4 p10">
            <div :class="'score' + ' ' + getScore(null, null, true)">Score: {{ getScore() }}</div>
            <md-button @click="showHistory=!showHistory" class="md-raised md-primary">{{showHistory? 'Hide' : 'Show'}} History</md-button>
            <div class="md-layout-item" v-show="showHistory">
              <div class="p10">
                History:
                <table>
                  <tr>
                    <th>Date</th>
                    <th>User</th>
                    <th>Status</th>
                    <th>Section</th>
                    <th>Score</th>
                  </tr>
                  <tr :key="submission.id" v-for="submission in historyFilter(submissions_all)">
                    <td>{{
                        $moment
                          .utc(parseInt(submission.createdAt))
                          .format("MM/DD/YYYY HH:mm")
                      }}</td>
                   <td><b>{{ submission.creator.roles.filter(e=>e.label=='faculty').length ? 'Faculty: ' : 'Student: ' }}</b> {{ submission.creator.firstName + ' ' + submission.creator.lastName }}</td>

                    <td>{{ submission.status }}</td>
                    <td>{{ submission.attempt_domain ? submission.attempt_domain.label: 'None' }}</td>
                    <td><span :class="getScore(submission.attempt_domain, submission, true)">{{ getScore(submission.attempt_domain, submission) }}</span></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div v-if="!isStudent() || isStudent() && student == user.id" class="assessment md-elevation-4 p10">
            <div class="md-layout-item legend">
              <div class="md-layout-item">
                <div class="p10" v-html="template.description"></div>
                <div v-if="template.file" class="p10">
                  Attachments:
                  <div :key="file.name" v-for="file in JSON.parse(template.file)">
                    <a target="_blank" :href="httpEndpoint + file.url">{{ file.name }}</a>
                  </div>
                </div>
              </div>
            </div>
            
            <md-tabs md-active-tab="tab-faculty">

              <md-tab @click="active_user_id = assessment.creator.id"
                id="tab-faculty" md-label="Faculty" :data-md-label="assessment.creator.firstName + ' ' + assessment.creator.lastName">
                <div v-if="competencies_by_user[assessment.creator.id] && haveAccess">
                  <div :class="'domein-section ' + (domain.multiple_attempts ? 'multiple' : '')" :key="domain.id" v-for="domain in template.childrens">
                    <div v-if="isFaculty() || isAdmin || (isStudent() && (!domain.multiple_attempts || submissions_by_attempt[domain.id] && submissions_by_attempt[domain.id].status == 'attempt_submitted'))">
                      <div class="md-layout md-alignment-center-center grade-row">
                        <div class="md-layout-item show-competency">
                          <md-button v-if="domain.childrens.length" @click="
                            show_competency[domain.id] = !show_competency[domain.id]
                            " class="md-icon-button md-raised md-accent">
                            <md-icon>{{
                              show_competency[domain.id]
                              ? "arrow_drop_up"
                              : "arrow_drop_down"
                            }}</md-icon>
                          </md-button>
                        </div>
                        <div class="md-layout-item competency-title" @click="
                        show_competency[domain.id] = !show_competency[domain.id]
                          ">
                          <md-checkbox v-show="!domain.req_grading && domain.childrens.length == 0" :disabled="isStudent() || submission && submission.status == 'submitted'
                            " v-model="competencies_by_user[assessment.creator.id][domain.id].status">
                            {{ domain.weight }}. {{ domain.label }}</md-checkbox>
                          <label v-show="!domain.req_grading && domain.childrens.length != 0 || domain.req_grading">{{ domain.weight }}. {{ domain.label }}</label> <span
                            class="required" v-if="domain.req_grading">*</span>
                        </div>
                        <div class="md-layout-item md-xsmall-size-100 competency-grade">
                          <div v-if="domain.childrens.length == 0">
                            <grade-control :template="domain" :readonly="isStudent() || submission.status == 'submitted' || attemptLock(domain.id)
                              " :grading="template.grading"
                              @change="onChangeGrade(domain.id, $event, true, domain.req_grading, assessment.creator.id)"
                              :value="competencies_by_user[assessment.creator.id][domain.id].grade" />
                          </div>
                        </div>
                      </div>
                      <div v-if="domain.childrens.length && show_competency[domain.id]">
                        <div :key="competency.id" v-for="(competency, index) in domain.childrens"
                          class="md-layout competency">
                          <div class="md-layout-item show-competency"></div>
                          <div class="md-layout-item">
                            <label class="md-checkbox" v-if="competency.parent.req_grading">{{ charFromCode(index) }}.
                              {{ competency.label }}</label>
                            <md-checkbox v-show="!competency.parent.req_grading
                              " :disabled="isStudent() || submission.status == 'submitted'" v-model="competencies_by_user[assessment.creator.id][competency.id].status">{{ charFromCode(index) }}.
                              {{ competency.label }}</md-checkbox>
                          </div>
                          <div class="md-layout-item md-xsmall-size-100 competency-grade">
                            <grade-control :template="domain.childrens[index]" :readonly="isStudent() || submission.status == 'submitted' || attemptLock(domain.id)
                              " :grading="template.grading"
                              @change="onChangeGrade(competency.id, $event, false, false, assessment.creator.id)"
                              :value="competencies_by_user[assessment.creator.id][competency.id].grade" />
                          </div>
                        </div>
                      </div>
                      <div style="padding-right: 50px;" v-if="domain.multiple_attempts && show_competency[domain.id]" class="md-layout-item text-right p10">
                        <div v-if="submissions_by_attempt[domain.id]">
                          <div :class="'score ' + getScore(domain.id, null, true)">{{ getScore(domain.id) }}</div>
                          <div>{{submissions_by_attempt[domain.id].status == 'attempt_submitted' ? 'Submited' : 'Saved'}} by: <b>{{ submissions_by_attempt[domain.id].creator.firstName }} {{ submissions_by_attempt[domain.id].creator.lastName }}</b></div>
                          <div>Date: {{ $moment
                            .utc(+submissions_by_attempt[domain.id].createdAt)
                            .format("MM/DD/YYYY hh:mm a") }}</div></div>
                        <md-button v-if="(isFaculty() || isAdmin)"  @click="onSaveAttempt(domain.id, 'draft')" class="md-raised md-secondary">Save</md-button>
                        <md-button v-if="(isFaculty() || isAdmin)" :disabled="attemptLock(domain.id)"  @click="onSubmitAttempt(domain.id)" class="md-raised md-accent">Submit</md-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="isStudent() && submitSelfAssessment">Please self evaluate to view your grades for this assessment</div>
              </md-tab>

              <md-tab
                v-if="template && template.student_self_assessment && current_student && current_student.id && competencies_by_user[current_student.id]"
                @click="active_user_id = current_student.id" id="tab-student"
                :md-label="(submissions[current_student.id] ? submissions[current_student.id].creator.firstName + ' ' + submissions[current_student.id].creator.lastName : current_student.firstName + ' ' + current_student.lastName) + (isFaculty() || isAdmin ? ' (Student)' : '')">
                <div class>
                  <div :key="domain.id" v-for="domain in template.childrens">
                    <div v-if="!domain.multiple_attempts || submissions_by_attempt[domain.id] && submissions_by_attempt[domain.id].status == 'attempt_submitted'">
                      <div class="md-layout md-alignment-center-center grade-row">
                        <div class="md-layout-item show-competency">
                          <md-button v-if="domain.childrens.length" @click="
                            show_competency[domain.id] = !show_competency[domain.id]
                            " class="md-icon-button md-raised md-accent">
                            <md-icon>{{
                              show_competency[domain.id]
                              ? "arrow_drop_up"
                              : "arrow_drop_down"
                            }}</md-icon>
                          </md-button>
                        </div>
                        <div class="md-layout-item competency-title" @click="
                        show_competency[domain.id] = !show_competency[domain.id]
                          ">
                          <md-checkbox v-show="!domain.req_grading && domain.childrens.length == 0"
                            :disabled="true"
                            v-model="competencies_by_user[assessment.creator.id][domain.id].status">
                            {{ domain.weight }}. {{ domain.label }}</md-checkbox>
                          <label v-show="!domain.req_grading && domain.childrens.length != 0 || domain.req_grading">{{ domain.weight }}. {{ domain.label }}</label> <span
                            class="required" v-if="domain.req_grading">*</span>
                        </div>
                        <div class="md-layout-item md-xsmall-size-100 competency-grade">
                          <div v-if="domain.childrens.length == 0">
                            <grade-control :template="domain" :readonly="current_student.id != user.id"
                              :grading="template.grading"
                              @change="onChangeGrade(domain.id, $event, true, domain.req_grading, current_student.id)"
                              :value="competencies_by_user[current_student.id][domain.id].grade" />
                          </div>
                        </div>
                      </div>
                      <div v-if="domain.childrens.length && show_competency[domain.id]">
                        <div :key="competency.id" v-for="(competency, index) in domain.childrens"
                          class="md-layout competency">
                          <div class="md-layout-item show-competency"></div>
                          <div class="md-layout-item">
                            <label class="md-checkbox" v-if="competency.parent.req_grading">{{ charFromCode(index) }}.
                              {{ competency.label }}</label>
                            <md-checkbox v-show="!competency.parent.req_grading
                              " :disabled="true
      " v-model="competencies_by_user[assessment.creator.id][competency.id].status">{{ charFromCode(index) }}.
                              {{ competency.label }}</md-checkbox>
                          </div>
                          <div class="md-layout-item md-xsmall-size-100 competency-grade">
                            <grade-control :template="domain.childrens[index]" :readonly="current_student.id != user.id
                              " :grading="template.grading"
                              @change="onChangeGrade(competency.id, $event, false, false, current_student.id)"
                              :value="competencies_by_user[current_student.id][competency.id].grade" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </md-tab>

            </md-tabs>

            <div class="required padding-left-50">* required fields</div>
          </div>
          <div v-if="!isStudent() || isStudent() && student == user.id" class="md-layout">
            <div class="md-layout-item md-xsmall-size-100 mr-5">
              <div class="md-layout table-label-wrapper">
                <div class="md-layout-item table-label p10">
                  <h1>Comment to Student</h1>
                </div>
                <div v-if="isFaculty() || isAdmin" class="md-layout-item text-right p10">
                  Visible to Student & Faculty
                </div>
              </div>
              <div class="assessment md-layout md-elevation-4 comment" :class="isFaculty() ? 'table-label-wrapper' : ''">
                <div class="md-layout-item table-label p10">
                  <md-field v-if="isFaculty() || isAdmin">
                    <label>Write a note to the student</label>
                    <md-textarea v-model="submission.comment_to_student"></md-textarea>
                  </md-field>
                  <div v-if="isStudent()">
                    {{ submission.comment_to_student }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isFaculty() || isAdmin" class="md-layout-item md-xsmall-size-100 ml-5">
              <div class="md-layout table-label-wrapper">
                <div class="md-layout-item table-label p10">
                  <h1>Notes to Faculty</h1>
                </div>
                <div class="md-layout-item text-right p10">
                  Only visible to you
                </div>
              </div>
              <div class="assessment md-layout table-label-wrapper md-elevation-4 comment">
                <div class="assessment md-layout-item p10">
                  <md-field v-if="isFaculty() || isAdmin">
                    <label>Write a note to faculty</label>
                    <md-textarea v-model="submission.notes_to_faculty"></md-textarea>
                  </md-field>
                </div>
              </div>
            </div>
            <div v-if="isStudent()" class="md-layout-item ml-5">
              <div class="md-layout table-label-wrapper">
                <div class="md-layout-item table-label p10">
                  <h1>Student Self Assessment</h1>
                </div>
              </div>
              <div class="assessment md-layout md-elevation-4 comment">
                <div class="md-layout-item table-label p10">
                  <md-field>
                    <label>Write a self assessment</label>
                    <md-textarea v-model="submission.student_self_assessment"></md-textarea>
                  </md-field>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isFaculty() || isAdmin" class="md-layout table-label-wrapper">
            <div class="md-layout-item table-label p10">
              <h1>Student Self Assessment</h1>
            </div>
          </div>
          <div v-if="isFaculty() || isAdmin" class="assessment md-layout md-elevation-4 comment">
            <div class="md-layout-item p10">
              {{ submission.student_self_assessment }}
            </div>
          </div>
          <div v-if="haveAccess" class="md-layout">
            <div class="md-layout-item text-right action-buttons p10">
              <md-button v-if="submission.id &&
                (isFaculty() || isAdmin) &&
                submission.status == 'draft'
                " @click="onDelete" class="md-primary">
                <md-icon>delete</md-icon>Delete
              </md-button>
              <md-button v-if="isFaculty() || isAdmin" @click="onSave" class="md-primary">
                <md-icon>system_update_alt</md-icon>Save as Draft
              </md-button>
              <md-button v-if="!isStudent() &&
                (!submission.status || submission.status != 'submitted') ||
                isStudent()
                " @click="onSubmit" class="md-raised md-accent">Submit</md-button>
            </div>
          </div>
        </div>
        <div v-else class="no-result apollo">No result</div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import GradeControl from "./GradeControl";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import RoleMixin from "./RoleMixin.vue";

export default {
  name: "Assessment",
  props: ["user", "isAdmin", "redirect"],
  mixins: [RoleMixin],
  components: {
    GradeControl,
    Loading,
  },
  beforeRouteLeave(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    if (this.changed) {
      this.confirmLeave = true;
      this.location = to;
      //next(false)
      return;
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    if (this.changed) {
      this.confirmLeave = true;
      this.location = to;
      //next(false)
      return;
    }
    next();
  },
  computed: {
    messageClassOldPass() {
      return {
        "md-invalid": this.validate && (this.old == "" || this.oldPassErr),
      };
    },
    messageClassNewPass() {
      return {
        "md-invalid": this.validate && this.password == "",
      };
    },
    messageClassRepeatPass() {
      return {
        "md-invalid": this.validate && this.repeat != this.password,
      };
    },
    grades() {
      if (!this.template || !this.template.grading || !this.template.grading.grades.length) {
        return [];
      }
      return this.template.grading.grades.map(res => res).sort((a, b) => {
        if (a.value < b.value) {
          return 1;
        }
        if (a.value > b.value) {
          return -1;
        }
        return 0;
      });
    },
    haveAccess() {
      
      let isSubmitted = this.submission.status == 'submitted' || this.submission.status == 'attempt_submitted' || this.submission.status == 'attempt_draft';
      let isCurrentUserAccess = this.user.id == this.student;
      return this.isStudent() && !this.submitSelfAssessment && isCurrentUserAccess && isSubmitted || this.isFaculty() || this.isAdmin;
    }
  },
  created() {
    console.log(this.$route.params.id);
  },
  mounted() {
    console.log("mounted");
    this.checkAssessment()
  },
  data() {
    return {
      confirmAssessmentList: [],
      confirmNewAssessment: false,
      showHistory: false,
      attemptDomain: null,
      active_user: null,
      active_user_id: null,
      current_student: null,
      httpEndpoint: location.host == 'localhost:8080' ? 'http://localhost:3000' : '',
      isLoading: false,
      templateQuery: require("../graphql/Template.gql"),
      submissionsQuery: require("../graphql/Submissions.gql"),
      usersQuery: require("../graphql/Users.gql"),
      templates: {},
      errors: [],
      location: null,
      saved: false,
      submitSelfAssessment: false,
      confirmDelete: false,
      confirmSave: false,
      confirmLeave: false,
      confirmSubmit: false,
      confirmAttemptSave: false,
      confirmAttemptSubmit: false,
      submitError: false,
      assessment: null,
      student_status: [],
      group: 0,
      base_grade: null,
      students: [],
      student: null,
      currentStudentIndex: null,
      startDate: null,
      validate: false,
      show_competency: {},
      submission: {},
      submissions: {},
      submissions_by_attempt: {},
      submissions_all: [],
      competencies: {},
      competencies_by_user: {},
      template: {},
      changed: false,
      resident: null,
    };
  },
  methods: {
    goToAssessment(assessment_id, student) {
      this.confirmNewAssessment = false;
      this.$router.push({
        name: "assessment_user",
        params: { id: assessment_id, user: student },
      });
    },
    async checkAssessment(student) {
      if(!student) {
        return;
      }
      debugger
      let assessment, assessments, assessmentsWithData;
      await this.$apollo
        .query({
          query: require("../graphql/AssessmentsWithSubmissions.gql"),
          fetchPolicy: "no-cache",
          variables: {
            offset: 0,
            limit: 5,
            order: "id",
            direction: "DESC",
            filter: {
              type: this.assessment.type,
              startDate: this.$moment(this.assessment.startDate)
                .format("YYYY-MM-DD"),
              startTime: this.assessment.startTime,
              group: this.assessment.group.id,
              status: null,
              creator: this.assessment.creator.id,
              templateId: this.assessment.template.id
            },
          },
        })
        .then((data) => {
          if (data.data.assessments.count > 0) {
            assessment = data.data.assessments.edges[0];
            assessments = data.data.assessments.edges;
            assessmentsWithData = data.data.assessments.edges.filter((el)=>{
              
              let studentSubmissions = el.submissionsAll.edges.filter((s)=>{
                
                return s.user && s.user.id == student;
              });
              return studentSubmissions.length;
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
            
        if (assessment) {
          if (student) {
            if (assessmentsWithData.length == 0) {
              this.$router.push({
                name: "assessment_user",
                params: { id: assessment.id, user: student },
              });
              return;
            }
            this.confirmNewAssessment = true;
            this.confirmAssessmentList = assessmentsWithData;
            return;
          }
          return;
        }
    },
    onConfirmNewAssessmentCancel() {
      this.confirmNewAssessment = false;
    },
    historyFilter(submissions) {
      return submissions.filter(sub=>{
        if (this.isAdmin || this.isGroupLeader()) {
          return true;
        }
        if (this.isStudent()){
          return sub.creator.id == this.user.id;
        } 
      });
    },
    getScoreClass() {

    },
    getScore(id, sub, score_class) {
      let type = 'domain';
      if (!id) {
        type = 'total';
      }
      if (type == 'total') {
        if (!sub) {
          sub = this.getLastSubmission();
        }
        if (!sub) {
          return 'N/A';
        }
        
        let grading = this.assessment.template && this.template.grading ? this.template.grading.label : null;
        let data;
        data = sub.submissionDatas.map(e=>e);
        if (grading && (grading == 'A / I / U ' || grading == 'Pass / Fail')) {
          
          let u = data.filter(e=>e.status&&e.grade == 0);
          if(u && u.length != 0) {
            if (score_class) {
              return 'failure';
            }
            return 'Fail';
          }
          else {
            if (score_class) {
              return 'excellent';
            }
            return 'Pass';
          }
        }
        if (grading && grading == '0 / 2 / 3 / 4') {
          let u = data.filter(e=>e.status&&e.grade == 0);
          if(u && u.length != 0) {
            if (score_class) {
              return 'failure';
            }
            return 0;
          }
          else {
            let v = data.filter(e=>e.status).map(e=>e.grade);
            let avg = function avg(array) {
              let sum = 0;
              for (let i = 0; i < array.length; i++) {
                  sum += array[i];
              }
              if (array.length == 0) {
                return 'N/A'
              }
              return (sum / array.length).toFixed(2)
            }
            let avg_score = avg(v);
            if (score_class) {
              if (avg_score < 2) {
                return 'failure';
              }
              if (avg_score > 2 && avg_score < 3) {
                return 'satisfactory';
              }
              if (avg_score > 3) {
                return 'excellent';
              }
            }
            return avg_score;
          }
        }
      } else {
        if (!sub) {
          sub = this.getLastSubmission(id);
        }
        if (!sub) {
          return 'N/A';
        }
        let grading = this.templates[sub.attempt_domain.id].grading ? this.templates[sub.attempt_domain.id].grading.label : null;
        let childrens = this.templates[sub.attempt_domain.id].childrens.map(e=>e.id);
        let data;
        if (childrens.length) {
          data = sub.submissionDatas.filter(e=>childrens.includes(e.template.id)).map(e=>e);
        }
        else {
          data = sub.submissionDatas.filter(e=>e.template.id == sub.attempt_domain.id).map(e=>e);
        }
        if (grading && (grading == 'A / I / U ' || grading == 'Pass / Fail')) {
          
          let u = data.filter(e=>e.status&&e.grade == 0);
          if(u && u.length != 0) {
            if (score_class) {
              return 'failure';
            }
            return 'Fail';
          }
          else {
            if (score_class) {
              return 'excellent';
            }
            return 'Pass';
          }
        }
        if (grading && grading == '0 / 2 / 3 / 4') {
          let u = data.filter(e=>e.status&&e.grade == 0);
          if(u && u.length != 0) {
            return 0;
          }
          else {
            let v = data.filter(e=>e.status).map(e=>e.grade);
            let avg = function avg(array) {
              let sum = 0;
              for (let i = 0; i < array.length; i++) {
                  sum += array[i];
              }
              return sum / array.length
            }
            let avg_score = avg(v);
            if (score_class) {
              if (avg_score < 2) {
                return 'failure';
              }
              if (avg_score > 2 && avg_score < 3) {
                return 'satisfactory';
              }
              if (avg_score > 3) {
                return 'excellent';
              }
            }
            return avg_score;
          }
        }
        console.log(data);
      } 
    },
    getLastSubmission(id) {
      if (!id) {
        return this.submissions_all.length && this.submissions_all[this.submissions_all.length - 1];
      }
      let subs = this.submissions_all.filter((e)=>{
        return e.attempt_domain && e.attempt_domain.id == id
      });
      return subs.length && subs[subs.length - 1];
    },
    attemptLock(id) {
      let subs = this.submissions_all.filter((e)=>{
        return e.attempt_domain && e.attempt_domain.id == id
      });
      
      return subs.length ? subs[subs.length - 1].status == 'attempt_submitted' : null;
    },
    valid() {
      
      if (
        this.submission.rotation ||
        this.submission.absent ||
        this.submission.void_value
      ) {
        return true;
      }
      this.errors = [];
      let user_id = this.assessment.creator.id;
      if (!this.current_student) {
        return false;
      }
      if (this.isStudent()) {
        user_id = this.current_student.id;
      }
      Object.keys(this.competencies_by_user[user_id]).map((index) => {
        
        let isDomain = !this.templates[index].parent.parent;
        
        let isNoChildrens = !this.templates[index].childrens || this.templates[index].childrens.length == 0;
        if (isDomain && !isNoChildrens) {
          
          return {
            template: index,
            ...this.competencies_by_user[user_id][index],
          };
        }
        if (this.isStudent() && this.template && this.template.student_self_assessment) {
          
          let parent = this.templates[index].parent.id;
          let parent_template = this.templates[parent];
          let sub = this.submissions_by_attempt[index] || this.submissions_by_attempt[parent];
          
          if (sub && (sub.status == "attempt_submitted" || sub.status == "submitted")) {
            if ((parent_template.multiple_attempts || this.templates[index].multiple_attempts) &&
              this.competencies_by_user[this.assessment.creator.id][index].status == true &&
              this.competencies_by_user[user_id][index].grade === null
            ) {
              this.errors.push({ template: this.templates[index] });
            }
          }
          if (!(parent_template.multiple_attempts || this.templates[index].multiple_attempts) &&
            this.competencies_by_user[this.assessment.creator.id][index].status == true &&
            this.competencies_by_user[user_id][index].grade === null
          ) {
            this.errors.push({ template: this.templates[index] });
          }
        }
        else {
          
          if (this.attemptDomain && this.templates[index].parent.id != this.attemptDomain && index != this.attemptDomain) {
            return {
              template: index,
              ...this.competencies_by_user[user_id],
            };
          }
          if (
            this.competencies_by_user[user_id][index].status == true &&
            this.competencies_by_user[user_id][index].grade === null
          ) {
            this.errors.push({ template: this.templates[index] });
          }
        }
        return {
          template: index,
          ...this.competencies_by_user[user_id],
        };
      });
      if (this.isStudent() && this.template && (this.template.student_self_assessment &&(!this.submission.student_self_assessment || this.submission.student_self_assessment == ''))) {
        this.errors.push({ template: { label: 'Self Assessment'}});
      }
      return this.errors.length == 0;
    },
    charFromCode(index) {
      let new_index = "a".charCodeAt(0) + index;
      return String.fromCharCode(new_index);
    },
    onStudentChange(event) {
      if (this.$route.params.user != event) {
        this.$router.push({
          name: "assessment_user",
          params: { id: this.assessment.id, user: event },
        });
        return;
      }
      //console.log(event)
      this.setActiveStudent();
    },
    async onNextStudent() {
      if (this.currentStudentIndex < this.students.length - 1) {
        this.isLoading = true;
        await this.checkAssessment(this.students[this.currentStudentIndex + 1])
        this.isLoading = false;
        return;
      }
      // if (this.currentStudentIndex < this.students.length - 1) {
      //   //++this.currentStudentIndex
      //   //this.student = this.students[this.currentStudentIndex]
      //   this.$router.push({
      //     name: "assessment_user",
      //     params: {
      //       id: this.assessment.id,
      //       user: this.students[this.currentStudentIndex + 1],
      //     },
      //   });
        //this.setActiveStudent()
      // }
    },
    async onPrevStudent() {
      if (this.currentStudentIndex > 0) {
        this.isLoading = true;
        await this.checkAssessment(this.students[this.currentStudentIndex - 1])
        this.isLoading = false;
        return;
      }
      // if (this.currentStudentIndex > 0) {
      //   //--this.currentStudentIndex
      //   //this.student = this.students[this.currentStudentIndex]
      //   //this.setActiveStudent()
      //   this.$router.push({
      //     name: "assessment_user",
      //     params: {
      //       id: this.assessment.id,
      //       user: this.students[this.currentStudentIndex - 1],
      //     },
      //   });
      // }
    },
    getSubmissions() {
      return this.$apollo
          .query({
            query: this.submissionsQuery,
            fetchPolicy: "no-cache",
            variables: {
              offset: 0,
              limit: 0,
              filter: {
                user: this.student,
                assessment: this.assessment.id,
                faculty: '-all-'
              },
            },
          })
          .then((data) => {
            this.submission = {};
            let submissions = {};
            this.submissions_all = [...data.data.submissions.edges];
            data.data.submissions.edges.forEach((sub) => {
              if (sub.creator && sub.creator.id) {
                submissions[sub.creator.id] = sub;
              }
              
              if (sub.status && sub.creator.roles.filter(e=>e.label!='student').length) {
                this.submission = Object.assign({}, sub);
              }
              if (sub.attempt_domain) {
                this.submissions_by_attempt[sub.attempt_domain.id] = Object.assign({}, sub);
              }
            });
            if (submissions[this.student]) {
              this.submission = { ...this.submission, student_self_assessment: submissions[this.student].student_self_assessment }
            }
            
            this.checkStudentSelfAssesment();

            return submissions;
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          })
    },
    checkStudentSelfAssesment() {
      if (
        this.isStudent() &&
        (this.submission.student_self_assessment == "" ||
          !this.submission.student_self_assessment || !this.valid())
      ) {
        this.submitSelfAssessment = true;
      }
      else {
        this.submitSelfAssessment = false;
      }
    },
    async setActiveStudent() {
      this.isLoading = true;
      this.base_grade = null;
      //this.student = this.students[this.currentStudentIndex];
      this.currentStudentIndex = this.students.indexOf(this.student);
      let submission = null;
      let user_data = [];
      user_data.push(
        this.getSubmissions()
      );
      // let template = {
      //   daily: 1,
      //   monthly: 32,
      // };
      user_data.push(
        this.$apollo
          .query({
            query: this.templateQuery,
            fetchPolicy: "no-cache",
            variables: {
              id: this.assessment.template.id,
            },
          })
          .then((data) => {
            let comp = {};
            let competencies = {};
            this.templates = {};
            this.template = {};
            this.template = data.data.template;
            for (let key in data.data.template.childrens) {
              let id = data.data.template.childrens[key].id;
              comp[id] = true;
              competencies[id] = {};

              let status = false;
              if (
                data.data.template.childrens[key].req_grading
                &&
                (!data.data.template.childrens[key].childrens || data.data.template.childrens[key].childrens.length == 0)
              ) {

                status = true;
              }
              this.templates[id] = data.data.template.childrens[key];
              competencies[id] = {
                grade: null,
                key: null,
                status: status,
              };

            }
            this.show_competency = comp;
            for (let key in data.data.template.childrens) {
              // let id = data.data.template.childrens[key].id;
              if (data.data.template.childrens[key].childrens.length) {
                for (let k in data.data.template.childrens[key].childrens) {
                  let id = data.data.template.childrens[key].childrens[k].id;
                  let status = false;
                  if (
                    data.data.template.childrens[key].req_grading
                  ) {
                    status = true;
                  }
                  this.templates[id] =
                    data.data.template.childrens[key].childrens[k];
                  competencies[id] = {
                    grade: null,
                    key: null,
                    status: status,
                  };
                }
              }
            }

            return competencies;
          })
          .catch(() => {
            this.isLoading = false;
          })
      );
      user_data.push(this.$apollo
        .query({
          query: this.usersQuery,
          fetchPolicy: "no-cache",
          variables: {
            offset: 0,
            limit: 1,
            filter: {
              id: this.student
            },
          },
        })
        .then((data) => {

          return data.data.users.edges[0] ? data.data.users.edges[0] : null;
        }).catch(() => { return null }));
      let self = this;
      return Promise.all(user_data)
        .then((data) => {
          let submissions = data[0];
          let competencies = data[1];

          let student = data[2];
          this.competencies = competencies;
          this.submissions = submissions;
          
          this.current_student = student;
          this.active_user_id = this.assessment.creator.id;
          this.competencies_by_user = {};

          Object.keys(submissions).forEach((key) => {
            let sub = submissions[key];
            ;
            this.competencies_by_user[sub.creator.id] = Object.assign({}, competencies);
            if (sub.submissionDatas) {
              sub.submissionDatas.forEach((data) => {
                if (data.template && data.template.id) {
                  let creator_submission = submissions[this.assessment.creator.id];
                  let creator_status;
                  if (creator_submission && creator_submission.submissionDatas) {
                    let creator_data = creator_submission.submissionDatas.filter((submission_data) => {
                      return submission_data.template && submission_data.template.id == data.template.id;
                    });
                    if (creator_data) {
                      creator_status = creator_data[0] ? creator_data[0].status : null;
                    }
                  }
                  let status = this.competencies_by_user[sub.creator.id][data.template.id].status ? this.competencies_by_user[sub.creator.id][data.template.id].status : data.status;
                  
                  if (creator_status) {
                    status = creator_status;
                    competencies[data.template.id].status = status;
                  }
                  this.competencies_by_user[sub.creator.id][data.template.id] = {
                    grade: data.grade === null ? null : parseFloat(data.grade),
                    key: data.key,
                    status: status,
                  };
                }
              });
            }
          });

          this.submissions_all.forEach((sub) => {
            // let sub = submissions[key];
            let creator_id = this.assessment.creator.id;
            if (!this.competencies_by_user[creator_id]) {
              this.competencies_by_user[creator_id] = Object.assign({}, competencies);
            }
            if (sub.submissionDatas && sub.attempt_domain) {
              sub.submissionDatas.forEach((data) => {
                
                let parent = this.templates[data.template.id].parent;
                if (data.template && data.template.id && (data.template.id == sub.attempt_domain.id || parent && parent.id == sub.attempt_domain.id)) {
                  let creator_submission = submissions[sub.creator.id];
                  let creator_status;
                  if (creator_submission && creator_submission.submissionDatas) {
                    let creator_data = creator_submission.submissionDatas.filter((submission_data) => {
                      return submission_data.template && submission_data.template.id == data.template.id;
                    });
                    if (creator_data) {
                      creator_status = creator_data[0] ? creator_data[0].status : null;
                    }
                  }
                  let status = this.competencies_by_user[sub.creator.id][data.template.id].status ? this.competencies_by_user[sub.creator.id][data.template.id].status : data.status;
                  
                  if (creator_status) {
                    status = creator_status;
                    competencies[data.template.id].status = status;
                  }
                  this.competencies_by_user[creator_id][data.template.id] = {
                    grade: data.grade === null ? null : parseFloat(data.grade),
                    key: data.key,
                    status: status,
                  };
                }
              });
            }
          });
          if (!this.competencies_by_user[this.assessment.creator.id]) {
            this.competencies_by_user[this.assessment.creator.id] = Object.assign({}, competencies);
          }
          if (!this.competencies_by_user[this.current_student.id]) {
            this.competencies_by_user[this.current_student.id] = Object.assign({}, competencies);
          }
          if (self.submission && self.submission.submissionDatas) {

            let competencies = Object.assign({}, self.competencies);
            self.competencies = {};

            self.submission.submissionDatas.forEach((data) => {
              if (data.template && data.template.id) {
                competencies[data.template.id] = {
                  grade: data.grade === null ? null : parseFloat(data.grade),
                  key: data.key,
                  status: competencies[data.template.id].status ? competencies[data.template.id].status : data.status,
                };
              }
            });
            self.competencies = competencies;
          }
          this.competencies_by_user = { ...this.competencies_by_user };
          this.isLoading = false;
          this.changed = false;
          
          this.checkStudentSelfAssesment();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onStudentLoad(data) {
      if (this.$route.params.user) {
        this.student = this.$route.params.user;
      } else {
        this.student = data.data.users.edges[0].id;
      }
      this.students = data.data.users.edges.map((student) => {
        return student.id;
      });
      this.currentStudentIndex = this.students.indexOf(this.student);
      this.setActiveStudent();
    },
    onAssessmentLoad(data) {
      if (data.data.assessment) {
        this.group = data.data.assessment.group
          ? data.data.assessment.group.id
          : null;
        this.startDate = this.$moment
          .utc(+data.data.assessment.startDate)
          .format("MM/DD/YYYY");

        this.endDate = data.data.assessment.endDate ? this.$moment
          .utc(+data.data.assessment.endDate)
          .format("MM/DD/YYYY") : null;

        this.assessment = data.data.assessment;
        this.resident = this.assessment.template.variation == 'resident';
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 300);
    },
    onResult() { },
    onSubmitAttempt(domain) {
      this.attemptDomain = domain;
      if (!this.valid()) {
        this.submitError = true;
        return;
      }

      this.confirmAttemptSubmit = true;
    },
    onSaveAttempt(domain) {
      this.attemptDomain = domain;
      this.confirmAttemptSave = true;
    },
    onSave() {
      this.confirmSave = true;
    },
    onSaveAttemptConfirm() {
      this.save("attempt_draft");
    },
    onSubmitAttemptConfirm() {
      this.save("attempt_submitted");
    },
    onSaveConfirm() {
      this.save("draft");
    },
    onDeleteConfirm() {
      this.delete();
    },
    onDelete() {
      this.confirmDelete = true;
    },
    async delete() {
      if (this.submission.id) {
        await this.$apollo
          .mutate({
            mutation: require("../graphql/DeleteSubmission.gql"),
            variables: {
              id: this.submission.id,
            },
          })
          .then(() => {
            window.location.reload();
          })
          .catch(() => { });
      }
    },
    async save(status) {
      let self = this;
      this.isLoading = true;
      this.submission
      let user_id = this.assessment.creator.id;
      
      let creator_id = this.user.id;
      
      if (this.isStudent()) {
        user_id = this.current_student.id;
      }
      if (status) {
        this.submission.status = status;
      }
      if (false) { // this.submissions[user_id] && !this.attemptDomain || status == 'attemp_draft') {
        await this.$apollo
          .mutate({
            mutation: require("../graphql/UpdateSubmission.gql"),
            variables: {
              rotation: this.submission.rotation,
              absent: this.submission.absent,
              void_value: this.submission.void_value,
              status: this.submission.status,
              procedure_note: this.submission.procedure_note,
              comment_to_student: this.submission.comment_to_student,
              notes_to_faculty: this.submission.notes_to_faculty,
              student_self_assessment: this.submission.student_self_assessment,
              id: this.submissions[user_id].id,
              attempt_domain: this.attemptDomain,
              submissionData: Object.keys(this.competencies_by_user[user_id]).map((index) => {
                return {
                  template: index,
                  ...this.competencies_by_user[user_id][index],
                };
              }),
              creator: creator_id,
              // assessment: this.assessment.id,
              // user: this.student
            },
          })
          .then((submission) => {
            self.submissions[user_id] = submission.data.updateSubmission;
            self.saved = true;
            return self.getSubmissions();
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {

        let user_id = this.assessment.creator.id;
        let creator_id = this.user.id;
        if (this.isStudent()) {
          user_id = this.current_student.id;
        }
        await this.$apollo
          .mutate({
            mutation: require("../graphql/CreateSubmission.gql"),
            variables: {
              rotation: this.submission.rotation,
              absent: this.submission.absent,
              void_value: this.submission.void_value,
              status: this.submission.status,
              procedure_note: this.submission.procedure_note,
              comment_to_student: this.submission.comment_to_student,
              notes_to_faculty: this.submission.notes_to_faculty,
              student_self_assessment: this.submission.student_self_assessment,
              assessment: this.assessment.id,
              user: this.student,
              creator: creator_id,
              attempt_domain: this.attemptDomain,
              submissionData: Object.keys(this.competencies_by_user[user_id]).map((index) => {
                return {
                  template: index,
                  ...this.competencies_by_user[user_id][index],
                };
              }),
            },
          })
          .then((submission) => {
            self.submissions[user_id] = submission.data.createSubmission;
            self.saved = true;
            //self.setActiveStudent()
            return self.getSubmissions();
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
      this.isLoading = false;
      this.changed = false;
      this.attemptDomain = null
    },
    onSubmit() {
      if (!this.valid()) {
        this.submitError = true;
        return;
      }

      this.confirmSubmit = true;
    },
    onSubmitConfirm() {
      this.save("submitted");
    },
    onComment() {
      if (!this.valid()) {
        this.submitError = true;
        return;
      }
      
      this.save();
      
      this.submitSelfAssessment = false;
    },
    onChangeGrade(comp_id, event, domain, required, user_id) {

      if (user_id) {
        let status =
          this.competencies_by_user[user_id][comp_id] && this.competencies_by_user[user_id][comp_id].status
            ? this.competencies_by_user[user_id][comp_id].status
            : null;
        let newVal = {
          grade: event.value === null ? null : parseFloat(event.value),
          key: event.key === null ? null : event.key,
          status: domain && required ? true : status,
        };
        this.competencies_by_user[user_id][comp_id] = newVal;
      }
      else {
        let status =
          this.competencies[comp_id] && this.competencies[comp_id].status
            ? this.competencies[comp_id].status
            : null;
        let newVal = {
          grade: event.value === null ? null : parseFloat(event.value),
          key: event.key === null ? null : event.key,
          status: domain && required ? true : status,
        };
        this.competencies[comp_id] = newVal;
      }

      this.changed = true;
    },
    onBaseGradeSelect() {
      let comps = {};
      let value = this.grades.filter((grade) => {
        return grade.key == this.base_grade;
      });
      if (value.length) {
        value = parseFloat(value[0].value);
      }
      else {
        value = null;
      }
      Object.keys(this.competencies_by_user[this.assessment.creator.id]).forEach((val) => {
        comps[val] = {
          grade: this.base_grade === null ? null : value,
          key: this.base_grade,
          status: this.competencies_by_user[this.assessment.creator.id][val].status,
        };
      });
      this.competencies_by_user[this.assessment.creator.id] = comps;
      this.changed = true;
    },
    onSaveCancel() { },
    onLeaveCancel() {
      this.changed = false;
      this.$router.push(this.location);
    },
    onLeaveSave() {
      this.changed = false;
      this.save("draft");
      //this.$router.push(this.location)
    },
    onDashboard() {
      this.submitSelfAssessment = false;
      this.$router.push({ path: "/" });
    },
  },
  watch: {
    redirect(to) {
      console.log(to);
      if (to) {
        this.$router.push(to);
      }
    },
    $route(to) {
      // react to route changes...
      if (to.name == "assessment" || to.name == "assessment_user") {
        this.student = to.params.user ? to.params.user : this.students[0];
        this.currentStudentIndex = this.students.indexOf(this.student);
        this.setActiveStudent();
      }
    },
    student_status() {
      this.changed = true;
    },
    submission: {
      handler() {
        this.changed = true;
      },
      deep: true,
    },
    // absent: this.submission.absent,
    // void_value: this.submission.void_value, '
  },
};
</script>

<style lang="scss" scoped>

.domein-section {
  &.multiple {
    > div {
      border: 1px solid rgba(198, 203, 212, 0.8);
      border-radius: 10px;
      margin-bottom: 10px;
      margin-right: -10px;
      margin-left: -10px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
.required {
  color: #e7343b;
}

.padding-left-50 {
  padding-left: 50px;
}

.competency-grade {
  max-width: 290px;
  margin-left: auto;
  padding-left: 50px;
}

.competency {
  .competency-grade {
    max-width: 290px;
    margin-right: -10px;
    padding-left: 50px;
  }
}

.student-control {
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;

  .prev,
  .next {
    max-width: 50px;
  }
}

.assessment-type-section {
  max-width: 140px;
}

.show-competency {
  text-align: center;
  max-width: 50px;

  .md-button {
    min-width: 20px;
    width: 20px;
    height: 20px;

    .md-icon {
      width: 18px;
      min-width: 18px;
      height: 18px;
      font-size: 18px !important;
    }
  }
}

.grade {
  display: inline-block;
  padding: 10px;
  text-align: center;
  margin: 5px;
  width: 45px;
  height: 45px;
  border: 1px solid #d6d6d6;
  border-radius: 50%;
}

.legend {
  background: #fafafa;
  margin: -10px -10px 10px;
  padding: 18px 24px;
  border-radius: 8px;

  span {
    padding: 0 20px;
  }
}



.procedure-note {
  padding: 8px;
  background-color: #f3f3f3;
  border-radius: 8px;
  min-height: 36px;
}

.comment {
  min-height: 174px;
}

.prev,
.next {
  .md-button.md-icon-button {
    width: 32px;
    min-width: 32px;
    height: 32px;

    .md-icon {
      width: 18px;
      min-width: 18px;
      height: 20px;
      font-size: 18px !important;
    }
  }

  .md-button.md-icon-button:not([disabled]) {
    .md-icon.md-theme-default.md-icon-font {
      color: #e42129;
    }
  }
}

.student-control-col {
  max-width: 320px;
  margin-right: auto;
}

.student-flags-col {
  text-align: right;
}

.md-field.md-theme-default.md-has-textarea {
  background-color: #f3f3f3;
  border-radius: 8px;
  padding-top: 10px;

  &.md-focused {
    label {
      display: none;
    }
  }

  &.md-has-value {
    label {
      display: none;
    }
  }
}

h2 {
  color: #424242;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-weight: 800;
  line-height: 48px;
}

.grade-row {
  border-bottom: 1px solid rgba(198, 203, 212, 0.2);
  margin-right: -10px;
  margin-left: -10px;
  min-height: 56px;
}

.md-layout.competency {
  border-bottom: 1px solid rgba(198, 203, 212, 0.2);
  min-height: 56px;
  // &:last-child {
  //   border-bottom: none;
  // }
}

.competency-title {
  color: #333333;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
}
</style>
